import React, { lazy, Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import withAdminLayout from '../../layout/withAdminLayout';
import { Spin } from 'antd';

const Dashboard = lazy(() => import('../../container/exchange/Index'));
const History = lazy(() => import('../../container/exchange/History'));
// const PendingPickup = lazy(() => import('../../container/exchange/PendingPickup'));
const ViewDetails      = lazy(() => import('../../container/exchange/ViewDetails'));
// const Processing = lazy(() => import('../../container/exchange/Processing'));


function ExchangeRoutes() {
    return (
        <Suspense
            fallback={
                <div className="spin">
                    <Spin />
                </div>
            }
        >
            <Routes>
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="history" element={<History />} />
                <Route path="awaiting_approval" element={<Navigate to="/asm/exchange/history" replace />} />
                <Route path="exchange_approved" element={<Navigate to="/asm/exchange/history" replace />} />
                <Route path="exchange_rejected" element={<Navigate to="/asm/exchange/history" replace />} />
                <Route path="viewdetail" element={<ViewDetails />} />
                <Route path="*" element={<Navigate to="dashboard" />} />
            </Routes>
        </Suspense>
    );
}

export default withAdminLayout(ExchangeRoutes);
